module.exports = __webpack_public_path__ + "static/media/multas_anotadas.98fb50e9.svg";